"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGFLockedTransferInfo = void 0;
const react_1 = require("react");
const apis_1 = require("../apis");
const useGFLockedTransferInfo = (orderId, orderType, page_token, type) => {
    const [error, setError] = (0, react_1.useState)();
    const [refreshing, setRefreshing] = (0, react_1.useState)(true);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [list, setList] = (0, react_1.useState)();
    const requestingRef = (0, react_1.useRef)(false);
    // 刷新
    const refresh = (0, react_1.useCallback)(() => {
        if (requestingRef.current) {
            return;
        }
        requestingRef.current = true;
        setRefreshing(true);
        (0, apis_1.withDrawProfitListAPI)(orderId, orderType, page_token, type).subscribe({
            next: (list) => {
                setError(undefined);
                setList(list);
                setRefreshing(false);
                requestingRef.current = false;
            },
            error: (error) => {
                setRefreshing(false);
                requestingRef.current = false;
                setError(error);
            },
        });
    }, [orderId, orderType, page_token, type]);
    // 加载更多
    const loadMore = (0, react_1.useCallback)(() => {
        if (!list || !list.results || !list.results.length) {
            // 没有请求到第一条数据的时候不能加载能多
            return;
        }
        if (!list.next_page_token) {
            return;
        }
        if (requestingRef.current) {
            return;
        }
        requestingRef.current = true;
        setLoading(true);
        (0, apis_1.withDrawProfitListAPI)(orderId, orderType, list.next_page_token, type).subscribe({
            next: (result) => {
                setError(undefined);
                const newList = Object.assign(Object.assign({}, result), { results: list.results.concat(result.results) });
                setList(newList);
                setLoading(false);
                requestingRef.current = false;
            },
            error: (error) => {
                setLoading(false);
                requestingRef.current = false;
                setError(error);
            },
        });
    }, [list, orderId, orderType, type]);
    // 默认加载第一次
    (0, react_1.useEffect)(() => {
        refresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        /** 数据 */
        list: list,
        /** 是否正在刷新 */
        refreshing: refreshing,
        /** 是否正在加载更多 */
        loading: loading,
        /** 刷新 */
        refresh: refresh,
        /** 加载更多 */
        loadMore: loadMore,
        /** 错误 */
        error: error,
    };
};
exports.useGFLockedTransferInfo = useGFLockedTransferInfo;
